/* ==========================================================================
   Droplet subscription toggle (main-product block "subscription_card")
   --------------------------------------------------------------------------
   The card is a skin over Skio's own plan picker, which stays in the page
   (visually hidden) as the source of truth. Every action clicks Skio's real
   radios or sets Skio's real frequency select, so Skio writes selling_plan
   into the product form exactly as it did before. The theme's custom.js then
   updates the button text and the sticky bar from that selling_plan value.

   The card never decides its own state: it always redraws from the form's
   selling_plan input, so it cannot show a plan the form doesn't have.

   Everything is looked up fresh on each event (no cached nodes), so the card
   keeps working if the theme or Skio re-renders any of it.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__dlSubsCard) return;
  window.__dlSubsCard = true;

  var DEFAULT_TRIES = 20;      // how many times to try switching the plan on at load
  var DEFAULT_GAP = 100;       // ms between tries
  var REVEAL_AFTER = 2000;     // show the real state by then; the default is only applied before this

  var userTouched = false;
  var startedAt = Date.now();

  /* ---------------------------------------------------------------- lookups */

  function card() {
    return document.querySelector('[data-dl-subs]');
  }

  function readData(el) {
    var node = el && el.querySelector('[data-dl-subs-data]');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (e) {
      if (window.console) console.warn('[dl-subs] data unreadable', e);
      return null;
    }
  }

  function picker(el) {
    var id = el.getAttribute('data-product-id');
    return (
      document.querySelector('fieldset[skio-plan-picker="' + id + '"][skio-main-product]') ||
      document.querySelector('fieldset[skio-plan-picker="' + id + '"]')
    );
  }

  function planInput(p) {
    return p ? p.querySelector('input[name="selling_plan"]') : null;
  }

  function subRadio(p) {
    return p ? p.querySelector('input[skio-selling-plan-group]') : null;
  }

  function oneRadio(p) {
    return p ? p.querySelector('input[skio-one-time]') : null;
  }

  function skioSelect(p) {
    return p ? p.querySelector('select[skio-selling-plans], select.skio-frequency') : null;
  }

  // Skio has bound this picker once it has an instance for it.
  function skioReady(p) {
    var list = window.SkioPlanPickerInstances;
    if (!p || !list || !list.length) return false;
    for (var i = 0; i < list.length; i++) {
      if (list[i] && list[i].$planPicker === p) return true;
    }
    return false;
  }

  function currentVariantId(el, data) {
    var form = document.getElementById(el.getAttribute('data-form-id'));
    var input = form ? form.querySelector('[name="id"]') : null;
    return input && input.value ? String(input.value) : data.firstVariant;
  }

  function hasOption(select, value) {
    if (!select || !value) return false;
    for (var i = 0; i < select.options.length; i++) {
      if (select.options[i].value === String(value)) return true;
    }
    return false;
  }

  function isOn(p) {
    var input = planInput(p);
    return !!(input && input.value);
  }

  /* ----------------------------------------------------------------- redraw */

  function setText(root, selector, text) {
    var nodes = root.querySelectorAll(selector);
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].textContent !== text) nodes[i].textContent = text;
    }
  }

  function render() {
    var el = card();
    if (!el) return;
    var data = readData(el);
    var p = picker(el);
    if (!data || !p) return;

    var on = isOn(p);
    var freq = el.querySelector('[data-dl-freq]');
    var planId = on ? planInput(p).value : (freq && freq.value) || data.defaultPlan;

    // Keep our frequency list showing the plan the form actually has.
    if (on && freq && freq.value !== planId && hasOption(freq, planId)) freq.value = planId;

    var variant = data.variants[currentVariantId(el, data)] || data.variants[data.firstVariant];
    if (variant) {
      var plans = variant.plans || {};
      var subPrice = plans[planId] || plans[data.defaultPlan];
      if (!subPrice) {
        for (var k in plans) {
          if (Object.prototype.hasOwnProperty.call(plans, k)) { subPrice = plans[k]; break; }
        }
      }
      setText(el, '[data-dl-onetime-price]', variant.price);
      setText(el, '[data-dl-price-was]', variant.price);
      if (subPrice) setText(el, '[data-dl-price-now]', subPrice);

      var was = el.querySelectorAll('[data-dl-was-wrap]');
      for (var w = 0; w < was.length; w++) was[w].hidden = !subPrice || subPrice === variant.price;
    }

    el.classList.toggle('is-on', on);
    el.classList.toggle('is-off', !on);

    var sw = el.querySelector('[data-dl-switch]');
    if (sw) sw.setAttribute('aria-checked', on ? 'true' : 'false');

    var one = el.querySelector('[data-dl-onetime]');
    if (one && one.checked === on) one.checked = !on;

    // Show the controls once they match the form. While the default is still
    // being applied, wait (briefly) so the card doesn't flash off then on.
    var waitingForDefault = data.defaultOn && !on && !userTouched && Date.now() - startedAt < REVEAL_AFTER;
    if (!waitingForDefault) el.classList.remove('is-pending');
    el.classList.add('is-ready');
  }

  function renderSoon() {
    render();
    // custom.js redraws the button 100ms after a change; redraw after it too.
    setTimeout(render, 160);
  }

  /* ---------------------------------------------------------------- actions */

  // custom.js redraws the button and syncs the sticky bar 100ms after Skio's
  // change event. Run it straight away too, so there is no moment where the
  // form has a plan but the buttons still say "Add to cart".
  function refreshThemeButton() {
    if (typeof window.updateSubscriptionUI !== 'function') return;
    try { window.updateSubscriptionUI(); } catch (e) { /* theme code, not ours */ }
  }

  function switchOn(el, p) {
    var radio = subRadio(p);
    if (!radio) return;

    if (!radio.checked) {
      radio.click();
    } else if (!isOn(p)) {
      // Checked before Skio was listening: tell Skio again.
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }

    var freq = el.querySelector('[data-dl-freq]');
    var want = freq ? freq.value : '';
    var select = skioSelect(p);
    if (select && want && select.value !== want && hasOption(select, want)) {
      select.value = want;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
    refreshThemeButton();
  }

  function switchOff(p) {
    var radio = oneRadio(p);
    if (!radio) return;
    if (!radio.checked) {
      radio.click();
    } else if (isOn(p)) {
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }
    refreshThemeButton();
  }

  function setOn(want) {
    var el = card();
    if (!el) return;
    var p = picker(el);
    if (!p) return;
    if (want) switchOn(el, p);
    else switchOff(p);
    renderSoon();
  }

  /* ----------------------------------------------------------------- events */

  // Any press inside the card, or any add-to-cart, counts as the customer choosing.
  document.addEventListener('pointerdown', function (e) {
    var el = card();
    if (el && el.contains(e.target)) userTouched = true;
  }, true);

  document.addEventListener('submit', function () {
    userTouched = true;
  }, true);

  document.addEventListener('click', function (e) {
    var el = card();
    if (!el || !el.contains(e.target)) return;
    userTouched = true;

    if (e.target.closest('[data-dl-switch]')) {
      e.preventDefault();
      userTouched = true;
      setOn(!el.classList.contains('is-on'));
      return;
    }

    // Tapping anywhere on the card while it's off switches the plan on.
    // Leave the frequency select alone so it can open normally.
    if (e.target.closest('[data-dl-card]') && !e.target.closest('[data-dl-freq]') && el.classList.contains('is-off')) {
      userTouched = true;
      setOn(true);
    }
  });

  document.addEventListener('change', function (e) {
    var el = card();
    if (!el) return;

    if (el.contains(e.target)) {
      if (e.target.matches('[data-dl-onetime]')) {
        userTouched = true;
        setOn(false);
      } else if (e.target.matches('[data-dl-freq]')) {
        userTouched = true;
        if (el.classList.contains('is-on')) setOn(true);
        else render();
      }
      return;
    }

    // Anything else touching Skio's picker (Skio itself, other scripts): redraw.
    var p = picker(el);
    if (p && p.contains(e.target)) renderSoon();
  });

  if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.PUB_SUB_EVENTS) {
    try {
      FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, function () {
        setTimeout(render, 60);
      });
    } catch (e) { /* older theme build without pubsub */ }
  }

  /* ------------------------------------------------------------------- init */

  function applyDefault(triesLeft) {
    var el = card();
    if (!el) return;
    var data = readData(el);
    var p = picker(el);

    if (!data || !p) {
      if (triesLeft > 0) setTimeout(function () { applyDefault(triesLeft - 1); }, DEFAULT_GAP);
      return;
    }

    // Only while the card is still hidden: once the customer has seen One Time
    // Purchase selected, the plan must never switch itself on.
    var stillHidden = el.classList.contains('is-pending') && Date.now() - startedAt < REVEAL_AFTER;

    if (data.defaultOn && !userTouched && !isOn(p) && stillHidden) {
      if (skioReady(p)) switchOn(el, p);
      if (triesLeft > 0) {
        render();
        setTimeout(function () { applyDefault(triesLeft - 1); }, DEFAULT_GAP);
        return;
      }
    }
    renderSoon();
  }

  function start() {
    applyDefault(DEFAULT_TRIES);
    // Whatever happens with the default, never leave the card hidden.
    setTimeout(render, REVEAL_AFTER + 50);
  }

  document.addEventListener('shopify:section:load', function () {
    startedAt = Date.now();
    userTouched = false;
    start();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
